var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var IconWarning = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, props = __rest(_a, ["size", "className"]);
    return (_jsx("span", __assign({ className: "mex-icon mex-icon--".concat(size, " ").concat(className) }, props, { children: _jsxs("svg", __assign({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("g", __assign({ clipPath: "url(#clip0_1_294)" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.50858 23.0585L12.5018 5.05888C14.0256 2.31439 17.9723 2.31435 19.4961 5.0588L29.4899 23.0584C30.9702 25.7245 29.0423 29.0001 25.9928 29.0001H6.00575C2.9563 29.0001 1.02838 25.7246 2.50858 23.0585ZM16 21.0001C15.1716 21.0001 14.5 21.6716 14.5 22.5001C14.5 23.3285 15.1716 24.0001 16 24.0001C16.8284 24.0001 17.5 23.3285 17.5 22.5001C17.5 21.6716 16.8284 21.0001 16 21.0001ZM14.8996 19.0001H17.0996L17.0996 11.0001H14.8996V19.0001Z" }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_1_294" }, { children: _jsx("rect", { width: "32", height: "32", fill: "white" }) })) })] })) })));
};
export default IconWarning;
